import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import cls from 'classnames/bind';

import Throbber from '@ott/throbber';

import _noop from 'lodash/noop';

import s from './InputTrigger.scss';

const mainLocator = 'InputTrigger';
const avaliableIconPlacement = ['left', 'right'];

const cx = cls.bind(s);

class InputTrigger extends PureComponent {
  static propTypes = {
    parentInputRef: PropTypes.func,
    isActive: PropTypes.bool,
    isInvalid: PropTypes.bool,
    isLoading: PropTypes.bool,
    hideThrobber: PropTypes.bool,
    hasBottomLine: PropTypes.bool,
    className: PropTypes.string,
    tabIndex: PropTypes.string,
    errorPlacement: PropTypes.oneOf(['top', 'bottom']),
    label: PropTypes.string,
    name: PropTypes.string, // used by FirstErrorShower
    children: PropTypes.node.isRequired,
    specificLocators: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    iconNode: PropTypes.node,
    iconPlacement: PropTypes.oneOf(avaliableIconPlacement),
  };

  static defaultProps = {
    parentInputRef: _noop,
    isActive: false,
    isInvalid: false,
    isLoading: false,
    hideThrobber: false,
    hasBottomLine: false,
    errorPlacement: 'bottom',
    tabIndex: '-1',
    specificLocators: [],
    iconNode: '',
    iconPlacement: 'right',
  };

  renderIcon() {
    const { iconNode, iconPlacement } = this.props;

    if (!iconNode || !avaliableIconPlacement.includes(iconPlacement)) {
      return null;
    }

    return <div className={cx('icon', `icon--${iconPlacement}`)}>{iconNode}</div>;
  }

  render() {
    const {
      label,
      name,
      children,
      className,
      isActive,
      isInvalid,
      isLoading,
      hideThrobber,
      hasBottomLine,
      iconNode,
      iconPlacement,
      tabIndex,
      errorPlacement,
      specificLocators,
      parentInputRef,
    } = this.props;

    return (
      <button
        ref={parentInputRef}
        className={cx(
          'InputTrigger',
          {
            'InputTrigger--isActive': isActive,
            'InputTrigger--isInvalid': isInvalid,
            'InputTrigger--hasBottomLine': hasBottomLine,
            'InputTrigger--withRightIcon': Boolean(iconNode) && iconPlacement === 'right',
            'InputTrigger--withLeftIcon': Boolean(iconNode) && iconPlacement === 'left',
          },
          className
        )}
        name={name}
        data-error-placement={errorPlacement}
        tabIndex={tabIndex}
        type="button"
        data-locator={cls(mainLocator, specificLocators)}
      >
        {label && <div className={s.label}>{label}</div>}
        {children}
        {hideThrobber ? null : <Throbber className={cx('throbber')} isVisible={isLoading} />}
        {this.renderIcon()}
      </button>
    );
  }
}

export default InputTrigger;
